<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar color="light">
        <ion-buttons slot="start">
          <ion-button color="primary" @click="closeModal()">
            <mdicon name="close"></mdicon>
          </ion-button>
        </ion-buttons>
        <ion-title>Installatie of component</ion-title>
        <ion-buttons slot="end"></ion-buttons>
      </ion-toolbar>

      <!-- Toon segmenten enkel als er bestaande componenten zijn -->
      <ion-toolbar color="light" v-if="existing_location_item_components.length > 0">
        <ion-segment v-model="mode" color="primary">
          <ion-segment-button value="existing">
            <ion-label>Bestaande componenten</ion-label>
          </ion-segment-button>
          <ion-segment-button value="new">
            <ion-label>Nieuwe componenten</ion-label>
          </ion-segment-button>
        </ion-segment>
      </ion-toolbar>
    </ion-header>

    <ion-content color="light">
      <Loading v-if="loading"></Loading>

      <div v-if="mode === 'existing'">
        <info-card :message="'De onderstaande componenten zijn reeds toegevoegd aan ' + location_item_name">
        </info-card>
        <ion-list :inset="true">
          <ion-accordion-group>
            <ion-accordion v-for="component_type in all_component_types" :key="component_type.uuid" color="custom-white"
              toggle-icon-slot="end">
              <!-- Toon de header enkel als er componenten voor dit type bestaan -->
              <ion-item slot="header" v-if="(groupedLocationItemComponents[component_type.uuid] || []).length > 0">
                <ion-label class="strong">{{ component_type.name }}</ion-label>
              </ion-item>
              <div slot="content">
                <ion-item v-for="location_item_component in (groupedLocationItemComponents[component_type.uuid] || [])"
                  :key="location_item_component.uuid" @click="selectExistingComponent(location_item_component)">
                  <mdicon slot="start"
                    :name="selected_existing_location_item_components.length > 0 && selected_existing_location_item_components[0].uuid === location_item_component.uuid ? 'checkbox-marked-circle' : 'checkbox-blank-circle-outline'"
                    :class="selected_existing_location_item_components.length > 0 && selected_existing_location_item_components[0].uuid === location_item_component.uuid ? 'text-primary' : 'text-medium'">
                  </mdicon>
                  <ion-label>{{ location_item_component.name }}</ion-label>
                </ion-item>
              </div>
            </ion-accordion>
          </ion-accordion-group>
        </ion-list>
        <ion-button class="mx-4 sticky-bottom" expand="block" color="primary" @click="addExisting()"
          v-if="selected_existing_location_item_components.length > 0">
          Component selecteren
        </ion-button>
      </div>

      <div v-if="mode === 'new'">
        <div v-if="!selected_component">
          <list :inset="true" :show_search="true" :items="getComponents" @open="selectComponent" @new="newComponent"
            :item_size="50" :max_items="30" :no_created_at="true" last_searched_section="components" :is_parent="true">
            <template v-slot:no-data>
              <p class="no-data-title">Geen componenten gevonden</p>
              <p class="no-data-subtitle">
                Staat het component dat je zoekt niet in de lijst? Vraag dan de beheerder om het toe te voegen.
              </p>
            </template>
          </list>
        </div>

        <template v-else-if="selected_component">
          <ion-list :inset="true" lines="inset">
            <ion-list-header class="small-list-header">
              <ion-label class="my-0">Installatie of component</ion-label>
            </ion-list-header>
            <ion-item>
              <ion-input v-model="selected_component.name"></ion-input>
              <ion-button slot="end" color="primary" size="small" fill="clear" @click="deselectComponent()">
                <mdicon name="close"></mdicon>
              </ion-button>
            </ion-item>
          </ion-list>

          <template v-if="!only_parents">

            <!-- Subcomponent -->
            <ion-list v-if="!add_subcomponents" :inset="true" lines="inset">
              <ion-list-header class="small-list-header">
                <ion-label class="my-0">Subcomponent</ion-label>
              </ion-list-header>
              <ion-item @click="add_subcomponents = true">
                <ion-input :readonly="true" placeholder="Optioneel subcomponent"></ion-input>
                <ion-button slot="end" color="primary" size="small" fill="clear" @click="deselectSubComponent()">
                  <mdicon name="pencil-outline"></mdicon>
                </ion-button>
              </ion-item>
            </ion-list>

            <div v-else-if="!sub_selected">
              <list :inset="true" :show_search="true" @open="selectSubComponent" :item_size="50" :max_items="30"
                :no_created_at="true" last_searched_section="components" :is_parent="false">
                <template v-slot:no-data>
                  <p class="no-data-title">Geen componenten gevonden</p>
                  <p class="no-data-subtitle">
                    Staat het component dat je zoekt niet in de lijst? Vraag dan de beheerder om het toe te voegen.
                  </p>
                </template>
              </list>
            </div>

            <template v-else-if="sub_selected && add_subcomponents">
              <ion-list :inset="true">
                <ion-list-header class="small-list-header">
                  <ion-label class="my-0">Subcomponent</ion-label>
                </ion-list-header>
                <ion-item>
                  <ion-input v-model="selected_subcomponent.name"></ion-input>
                  <ion-button slot="end" color="primary" size="small" fill="clear" @click="deselectSubComponent()">
                    <mdicon name="close"></mdicon>
                  </ion-button>
                </ion-item>
              </ion-list>
            </template>
          </template>
        </template>

        <!-- Button -->
        <ion-button class="mx-4 sticky-bottom" expand="block" color="primary" @click="next()"
          v-if="selected_component && (!add_subcomponents || (add_subcomponents && sub_selected))">
          Doorgaan
        </ion-button>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import RowSelectModal from "./RowSelectModal.vue";
import module_parser from "@/services/module_parser";
import { db } from "@/services/db";
import PreSuffixInclude from "@/components/PreSuffixInclude.vue";
import List from "@/components/ComponentList";
import uuid from "@/plugins/uuid";
import {
  modalController,
  IonAccordion,
  IonAccordionGroup,
  IonSegment,
  IonSegmentButton,
  IonToggle
} from "@ionic/vue";

export default {
  name: "AddToBulkModal",
  props: {
    location_item_uuid: String,
    location_item_name: String,
    only_parents: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RowSelectModal,
    IonSegment,
    IonSegmentButton,
    IonAccordion,
    IonAccordionGroup,
    List,
    PreSuffixInclude,
    IonToggle
  },
  data() {
    return {
      mode: "existing",
      loading: true,
      show_modal: true,
      selected_existing_location_item_components: [],
      selected_component: null,
      edited_components: [],
      all_component_types: [],
      existing_location_item_components: [],
      valid_parent_uuids: [], // Added to track valid parent UUIDs
      components: [],
      selected_subcomponent: null,
      sub_selected: false,
      add_subcomponents: false,
      sub_components: [],
    };
  },
  created() {
    this.setup();
  },
  methods: {
    async next() {
      if (this.mode === "existing") {
        this.addExisting();
      } else {
        this.addNew();
      }
    },
    deselectComponent() {
      this.selected_component = null;
    },
    deselectSubComponent() {
      this.selected_subcomponent = null;
      this.sub_selected = false;
    },
    async selectSubComponent(subcomponent) {
      this.sub_selected = true;
      this.selected_subcomponent = subcomponent;
    },
    async newComponent(component) {
      let url = '/components';
      await this.$requests.post('components', url, component, 'base_components')
        .then(response => {
          this.selectComponent(component);
          console.log(response);
        }).catch(error => {
          this.$toast.error('Fout bij aanmaken component');
        });
    },
    selectComponent(component) {
      this.selected_component = component;
    },
    async setup() {
      this.loading = true;
      try {
        // Haal alle location_item_components op met de gegeven location_item_uuid
        let all_location_item_components = await db.location_item_components
          .where("location_item_uuid")
          .equals(this.location_item_uuid)
          .toArray();

        // Verzamel alle geldige parent UUIDs (componenten zonder parent of met bestaande parent)
        this.valid_parent_uuids = all_location_item_components
          .filter(item => !item.parent_uuid)
          .map(item => item.uuid);

        // Filter out components with invalid parent_uuid
        let valid_location_item_components = all_location_item_components.filter(item => {
          // If it has no parent, it's valid
          if (!item.parent_uuid) {
            return true;
          }
          // If it has a parent, check if the parent exists
          return this.valid_parent_uuids.includes(item.parent_uuid);
        });

        // Update the valid_parent_uuids with current valid components
        this.valid_parent_uuids = valid_location_item_components
          .map(item => item.uuid);

        // Bepaal alle component types voor de accordion
        let componentUuids = valid_location_item_components.map(l => l.component_uuid);
        let all_components = await db.base_components.where("uuid").anyOf(componentUuids).toArray();
        // Verwijder duplicaten
        all_components = [...new Set(all_components)];

        this.all_component_types = all_components.map(component => ({
          uuid: component.uuid,
          name: component.name,
        }));

        // Filter enkel types die in de opgehaalde componenten voorkomen
        this.all_component_types = this.all_component_types.filter(component_type =>
          valid_location_item_components.some(lic => lic.component_uuid === component_type.uuid)
        );

        // Sorteer de component types op naam
        this.all_component_types.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
        );

        // Haal alle base components op en sorteer ze
        this.components = await db.base_components.toArray().then(components => {
          components.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
          );
          return components;
        });

        // Sorteer de bestaande location_item_components op naam
        this.existing_location_item_components = valid_location_item_components.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
        );

      } catch (error) {
        console.error("Error in setup:", error);
        this.$toast.error('Fout bij laden van componenten');
      } finally {
        this.loading = false;
      }
    },
    async addExisting() {
      let loc = this.selected_existing_location_item_components[0];
      
      // Verify that if this is a child component, its parent exists
      if (loc.parent_uuid) {
        const parent = this.existing_location_item_components.find(item => item.uuid === loc.parent_uuid);
        if (parent) {
          await modalController.dismiss({
            parent_uuid: parent.uuid,
            sub_uuid: loc.uuid,
            parent_name: parent.name,
            sub_name: loc.name,
          }, "confirm");
        } else {
          this.$toast.error('Fout: Oudercomponent bestaat niet');
        }
      } else {
        await modalController.dismiss({
          parent_uuid: loc.uuid,
          sub_uuid: null,
          parent_name: loc.name,
          sub_name: null,
        }, "confirm");
      }
    },
    async addNew() {
      this.loading = true;

      try {
        const parent_component = this.selected_component;
        const sub_component = this.selected_subcomponent;

        const parent_location_item_component_uuid = uuid();
        const sub_location_item_component_uuid = uuid();
        let locs_to_be_stored = [];

        if (parent_component) {
          let parent_location_item_component = {
            location_item_uuid: this.location_item_uuid,
            uuid: parent_location_item_component_uuid,
            component_uuid: parent_component.uuid,
            name: parent_component.name,
            inspection_id: this.$store.getters.getInspectionId,
            parent_uuid: null,
            order_id: 0,
          };

          let state = {
            opened: sub_component ? false : true,
            uuid: parent_location_item_component.uuid,
          };

          this.$store.dispatch("setLocationItemComponentState", state);
          locs_to_be_stored.push(parent_location_item_component);

          if (sub_component) {
            let sub_location_item_component = {
              location_item_uuid: this.location_item_uuid,
              uuid: sub_location_item_component_uuid,
              component_uuid: sub_component.uuid,
              name: sub_component.name,
              inspection_id: this.$store.getters.getInspectionId,
              parent_uuid: parent_location_item_component_uuid, // Always has a valid parent since we just created it
              order_id: 0,
            };

            let state = {
              opened: false,
              uuid: sub_location_item_component.uuid,
            };

            this.$store.dispatch("setLocationItemComponentState", state);
            locs_to_be_stored.push(sub_location_item_component);
          }

          const url = "/inspections/" + this.$store.getters.getInspectionId + "/bulk-location-item-components";

          await this.$requests.post("location_item_components", url, {
            location_item_components: locs_to_be_stored,
          });

          await modalController.dismiss({
            parent_uuid: parent_location_item_component_uuid,
            sub_uuid: sub_component ? sub_location_item_component_uuid : null,
            parent_name: parent_component.name,
            sub_name: sub_component ? sub_component.name : null,
          }, "confirm");
        }
      } catch (error) {
        console.error("Error in addNew:", error);
        this.$toast.error('Fout bij toevoegen van componenten');
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      modalController.dismiss(null, "cancel");
    },
    // Zorgt ervoor dat er slechts één bestaand component geselecteerd kan worden
    selectExistingComponent(location_item_component) {
      if (this.selected_existing_location_item_components.length > 0 && this.selected_existing_location_item_components[0].uuid === location_item_component.uuid) {
        this.selected_existing_location_item_components = [];
      } else {
        this.selected_existing_location_item_components = [location_item_component];
      }
    },
    // Past de groepsselectie aan zodat enkel het eerste component in de groep geselecteerd wordt
    selectAllExistingComponents(component_uuid) {
      const group = this.groupedLocationItemComponents[component_uuid] || [];
      if (group.length === 0) {
        return;
      }
      if (this.selected_existing_location_item_components.length > 0 &&
        this.selected_existing_location_item_components[0].component_uuid === component_uuid) {
        this.selected_existing_location_item_components = [];
      } else {
        this.selected_existing_location_item_components = [group[0]];
      }
    },
    sortComponents(items) {
      return items.sort((a, b) =>
        a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
      );
    },
  },
  computed: {
    getComponents() {
      return this.components ? this.sortComponents(this.components) : [];
    },
    // Groepeert de bestaande location_item_components per component_uuid en sorteert ze
    groupedLocationItemComponents() {
      const groups = {};
      this.existing_location_item_components.forEach(item => {
        if (!groups[item.component_uuid]) {
          groups[item.component_uuid] = [];
        }
        groups[item.component_uuid].push(item);
      });
      Object.keys(groups).forEach(key => {
        groups[key].sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: "base" })
        );
      });
      return groups;
    },
  },
  watch: {
    // Als er geen bestaande componenten zijn, zet de mode automatisch op "new"
    existing_location_item_components(newVal) {
      if (newVal.length === 0) {
        this.mode = "new";
      }
    }
  },
};
</script>

<style lang="">
  /* Voeg hier eventueel je aangepaste CSS toe */
</style>